module.exports = new __parcel__URL__("chat-emojis.ced55590.svg").toString();